import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { SessionService }                       from '../sessions/session.service';
import { VehicleRegistrationService }           from './vehicle-registration.service';
import { VehicleRegistrationSettingsComponent } from './vehicle-registration.settings.component';

export const VehicleRegistrationsStates : Array<NgHybridStateDeclaration> = [
  {
    component: VehicleRegistrationSettingsComponent,
    name     : 'app.vehicle-registration-settings',
    resolve  : [
      {
        deps     : [ VehicleRegistrationService ],
        resolveFn: ( registrationService : VehicleRegistrationService ) : Promise<number> => registrationService.getRequests(),
        token    : 'requests'
      },
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : Promise<any> => sessionService.refresh(),
        token    : 'session'
      }
    ],
    url: '/vehicle-registration-settings'
  }
];
